import styled from 'styled-components'

export const Footer = styled.footer`
   background: rgb(239, 239, 239);
  display: flex;
  justify-content: flex-end;
  padding: 1.6rem;

`
